/** AI Instructions (Legacy) service — the API calls these "personalities". */
import constants from '../../constants'
import { getChatApiBase, getChatApiHeaders } from '../chatApiClient'
import axios from '../axiosInstance'
import {
  ChatApp,
  AiInstructionAddPayload,
  AiInstructionUpdatePayload,
  AiInstructionListResponse,
  AiInstructionResponse,
} from './types'

/** Takes an explicit `limit` the other two lists don't. */
export async function list(
  app: ChatApp,
  apiHost: string,
  pageNo = 1,
  limit: number = constants.perPageInListings,
): Promise<AiInstructionListResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities?per_page=${limit}&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function get(
  id: string,
  app: ChatApp,
  apiHost: string,
): Promise<AiInstructionResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities/${id}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function add(
  post: AiInstructionAddPayload,
  app: ChatApp,
  apiHost: string,
): Promise<AiInstructionResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function update(
  id: string,
  post: AiInstructionUpdatePayload,
  app: ChatApp,
  apiHost: string,
): Promise<AiInstructionResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function del(
  id: string,
  app: ChatApp,
  apiHost: string,
): Promise<AiInstructionResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/personalities/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}
